const t = {
  Summary: "SUMMARY",
  Detailed: "DETAILED"
};
function e(o) {
  return r(o);
}
function r(o, n) {
  return o;
}
function i(o) {
  return o;
}
export {
  t as Projection,
  e as ProjectionFromJSON,
  r as ProjectionFromJSONTyped,
  i as ProjectionToJSON
};
//# sourceMappingURL=Projection.js.map
